module.exports = __webpack_public_path__ + "images/logo__f96816dd0fee643c79d11549120ea449.png";